import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

/** Route titles are translation keys; re-applies the document title when the language changes. */
@Injectable({ providedIn: 'root' })
export class RegHubTitleStrategy extends TitleStrategy {
  private readonly transloco = inject(TranslocoService);
  private titleKey: string | undefined;

  constructor(private readonly title: Title) {
    super();
    this.transloco.langChanges$.subscribe(() => this.apply());
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    this.titleKey = this.buildTitle(routerState);
    this.apply();
  }

  private apply(): void {
    const title = this.titleKey ? this.transloco.translate(this.titleKey) : '';
    this.title.setTitle(title ? `${title} - RegHub` : 'RegHub');
  }
}
